export default "__VITE_PUBLIC_ASSET__92317513__"